import axios from 'axios'
import {objectToQueryString} from '@/utils/playerHelpers'

interface Payload {
  body: FormData
  bjId: string
}

export const getInfoPlayer = async (payload: Payload) => {
  try {
    const response = await axios.post(
      'https://live.onlive.vn/afreeca/player_live_api.php?bjid=' + payload.bjId,
      payload.body,
      {withCredentials: true},
    )
    return response.data
  } catch (error) {
    console.log(error)
  }
}

const getKeyLink = async (szBjId?: string, nBroadNo?: string, password?: string, quality?: string) => {
  if (!szBjId || !nBroadNo || !password) return
  try {
    const data = objectToQueryString({
      bid: szBjId,
      bno: nBroadNo,
      type: 'aid',
      pwd: password,
      player_type: 'html5',
      stream_type: 'common',
      quality: quality,
      mode: 'landing',
      from_api: 0,
    })
    const response = await fetch(
      process.env.NEXT_PUBLIC_LIVE +
        '/afreeca/player_live_api.php?bjid=' +
        szBjId,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        // mode: 'cors',
        credentials: 'include',
        body: data,
      },
    ).then((res) => res.json())
    return response
  } catch (error) {
    console.log(error)
  }
}

const getLink = async (nBroadNo?: string) => {
  if (!nBroadNo) return
  try {
    const response = await fetch(
      process.env.NEXT_PUBLIC_LIVESTREAM + 
        `/broad_stream_assign.html?return_type=gcp_cdn&broad_key=${nBroadNo}-common-original-hls`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        credentials: 'include',
      },
    ).then((res) => res.json())
    console.log('getLink', {response})
    return response
  } catch (error) {
    console.log(error)
  }
}


export const getCdnUrlWithPass = async (szBjId?: string, nBroadNo?: string, password?: string, quality?: string) => {
  if (!szBjId || !nBroadNo) return undefined
  try {
    const response1 = getKeyLink(szBjId, nBroadNo, password, quality)
    const response2 = getLink(nBroadNo)
    const [liveInfo, cdnStream] = await Promise.all([response1, response2])
    console.log({liveInfo, cdnStream})

    if (liveInfo?.CHANNEL?.RESULT == 0) {
      return 0
    }
    return `${cdnStream.view_url}?aid=${liveInfo?.CHANNEL?.AID}`
  } catch (error) {
    console.log(error)
  }
}

export const getInfo = async (nBroadNo?: string) => {
  if (!nBroadNo) return
  try {
    const response = await fetch(`https://live.onlive.vn/api/get_broad_info.php?broad_no=${nBroadNo}`,
      {
        method: 'GET',
        cache: 'no-cache',
      },
    ).then((res) => res.json())
      return response
    } catch (error) {
      console.log(error)
  }
}

export const getInfoLive = async (szBjId?: string, nBroadNo?: string) => {
  if (!szBjId || !nBroadNo) return
  try {
    const data = objectToQueryString({
      bid: szBjId,
      bno: nBroadNo,
      type: 'live',
      pwd: '',
      player_type: 'html5',
      stream_type: 'common',
      quality: 'HD',
      mode: 'landing',
      from_api: 0,
    })
    const response = await fetch(`https://live.onlive.vn/afreeca/player_live_api.php?bjid=${szBjId}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        credentials: 'include',
        body: data,
      },
    ).then((res) => res.json())
      return response
    } catch (error) {
      console.log(error)
  }
}
